import Parse from 'parse'

import User from './models/User'
import WishList from './models/WishList'
import Players from './models/Players'
import SlideShow from './models/SlideShow'
import Country from './models/Country'
import League from './models/League'
import Inbox from './models/Inbox'



Parse.Object.registerSubclass('_User', User)
Parse.Object.registerSubclass('WishList', WishList)
Parse.Object.registerSubclass('Player', Players)
Parse.Object.registerSubclass('Slideshow', SlideShow)
Parse.Object.registerSubclass('Country', Country)
Parse.Object.registerSubclass('League', League)
Parse.Object.registerSubclass('Inbox', Inbox)

//--prod 
Parse.initialize('84bc7023-7559-4723-b998-1f2c4880ca58', '564577fa-2057-4777-9017-f2c2ef4529a8')
//--prod 
Parse.serverURL = 'https://pragmatic-production.herokuapp.com/api'

//--dev Parse.initialize('42fd9c1b-9de3-4bf0-8e1e-7d7bb1e1576c', 'fc7a3fd9-bb14-4db7-a265-39ba5fab7116')
//--dev Parse.serverURL = 'https://pragmatic-staging.herokuapp.com/api'

export default Parse